<template lang="pug">
    // h1 Lista de Lotes de Solicitudes de Abastecimiento!
    v-container( fluid )
        v-layout( row wrap )
            v-flex( xs12 )
                crud-data-table(
                    :service="service"
                    :headers="headers"
                    :filters="filters"
                    @show="$router.push('/bill_batch_list/'+$event)"
                    :deleteButton="() => false"
                    ref="refCrudDTBatchBill"
                    )
</template>

<script>
// -
import { CrudDataTable } from '@/components/reusable_components'
import {mapActions, mapState} from 'vuex'
import BatchListHeaders from './BatchListHeaders'
import FilterBatchList from './BatchListFilters'
import FetchAllEmployeeService from '@/services/API/employee'
//-
import { getFetchDataFunction } from '@/services/API/DataTableService'
import DispReqBatchModel from '@/models/Warehouse/WhDispatchRequestBatch'
import DRBIncludes from '@/services/API/dispatchRequestBatch/DispatchRequestBatchIncludes'

export default {
    name: 'bill-batch-list',
    props: {},
    data: function(){
        return {
            service: {
                dtFetchData: {}
            },
            headers: BatchListHeaders,
            filters: FilterBatchList,
        }
    },
    computed: {},
    methods: {
        //-
        setFilterOptions(index, options) {
            this.filters[index].options = options
        },
        // - 0
        mapSupervisorToFilter: ({ names, last_name1, last_name2, id }) => ({
            text: `${names} ${last_name1} ${last_name2}`,
            value: id,
        }),
        //- 
        fetchTableData: function() {
            const url = process.env.VUE_APP_API_ROUTE.concat(`/wh_dispatch_request_batch?filter[non_billed]=1`)
            const includes = ['supervisor_g_user', 'supervisor_g_user.hr_employee', 'g_state']
            this.service.dtFetchData = getFetchDataFunction(url, includes, null, null)
        },
        // getModel: function() {
        //     let model = DispReqBatchModel
        //     model = model.where('g_state_id', 26)
        //     model = model.include([...DRBIncludes])
        //     return model
        // },
    },
    watch: {},
    components: {
        'crud-data-table': CrudDataTable,
    },
    mixins: [],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    beforeMount: async function(){
        this.setFilterOptions(
            0,
            (await FetchAllEmployeeService.fetchAll()).map(this.mapSupervisorToFilter)
        )
    },
    mounted: function(){
        this.fetchTableData()
    },
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss">
    
</style>